import { render, staticRenderFns } from "./addRes.vue?vue&type=template&id=56b3bc9c&scoped=true&"
import script from "./addRes.vue?vue&type=script&lang=js&"
export * from "./addRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b3bc9c",
  null
  
)

export default component.exports